import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Trophy, Star, Users } from "lucide-react";
import {
  getEventDetail,
  getStarTransactions,
  claimReward,
  addAddressId,
  getAddress,
  removeAddressId,
  deleteCartId,
} from "../Services/Service.js";
import {
  begin_checkout,
  refund,
  remove_from_cart,
  view_cart,
} from "../Services/events";
import RegisterWinModal from ".././components/RegisterWinModal.js";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import BottomLogin from "./bottomLogin";
import { useNavigate } from "react-router-dom";
import { Gift, User } from "lucide-react";
import { motion } from "framer-motion";
import Confetti from "react-confetti";
import "./event.css";
import Modal from "react-bootstrap/Modal";
const initialValue = {
  name: "",
  firstName: "",
  lastName: "",
  mobile: "",
  addressId: "",
  email: "",
  address: "",
  landmark: "",
  city: "",
  pinCode: "",
  state: "",
  isDefault: "N",
};
const Events = () => {
  let statusIcon;
  let statusColor;
  let percentile = 60;
  if (percentile <= 10) {
    statusIcon = <Trophy className="w-6 h-6 animate-pulse-glow" />;
    statusColor = "text-game-success border-game-success";
  } else if (percentile <= 30) {
    statusIcon = <Star className="w-6 h-6" />;
    statusColor = "text-game-warning border-game-warning";
  } else {
    statusIcon = <Users className="w-6 h-6" />;
    statusColor = "text-game-primary border-game-primary";
  }

  const nav = useNavigate();
  const isComplete = "Y";
  const [eventDetails, setEventDetails] = useState(null);
  const [starTransaction, setStarTransaction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isNotification, setIsNotification] = useState("N");
  const [issOpen, setOpen] = useState(false);
  const [order_id, setOrder_id] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [addressCards, setAddressCards] = useState([]);
  const [show, setShow] = useState(false);
  const [varient, setVarient] = useState("success");
  const [msg, setMsg] = useState("");
  const [display, setDisplay] = useState(false);
  const [user, setUser] = useState(initialValue);
  const [formErrors, setFormErrors] = useState("");
  const [checkedAdd, setCheckedAdd] = useState(false);
  const [showEventDetails, setShowEventDetails] = useState(false);
  const [showStoreDetails, setShowStoreDetails] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [spicegoldExpanded, setSpicegoldExpanded] = useState(false);

  // const [isShown, setIsShown] = useState({});
  useEffect(() => {
    getEventDetailCall();
    getStarTransactionsCall();
  }, []);

  function emailValidation() {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!user.email || regex.test(user.email) === false) {
      setFormErrors("Email is invalid");
      return false;
    }
    return true;
  }

  function validateForm(e) {
    if (user.name.length < 4) {
      setFormErrors("Please Enter Name");
      return false;
    } else if (user.mobile.length !== 10) {
      setFormErrors("Please Enter 10 digit Mobile No.");
      return false;
    } else if (!emailValidation()) {
      setFormErrors("Please enter valid Email");
      return false;
    } else if (user.address.length < 10) {
      setFormErrors("Please Enter 10 characters in Address 1");
      return false;
    } else if (user.landmark.length < 10) {
      setFormErrors("Please Enter 10 characters in Landmark");
      return false;
    } else if (user.pinCode.length !== 6) {
      setFormErrors("Please Enter 6 digit pincode");
      return false;
    } else if (user.city.length < 3) {
      setFormErrors("Please Enter City");
      return false;
    } else if (user.state.length < 3) {
      setFormErrors("Please Enter State");
      return false;
    } else {
      setFormErrors("");
      return true;
    }
  }
  const submitHandle = async (e) => {
    e.preventDefault();

    const isValidForm = validateForm(e);
    if (!isValidForm) return;

    try {
      const response = await addAddressId(user);
      if (response?.data?.status === 1) {
        setShowAddForm(false);
        try {
          fetchAddresses();
          setUser(initialValue);
        } catch (error) {
          console.error("Failed to claim reward:", error);
        } finally {
        }
      } else {
        console.error("Failed to add address:", response?.data?.message);
      }
    } catch (error) {
      console.error("Error while adding address:", error);
    } finally {
    }
  };
  const onValueChange = (e) => {
    // setCheckedAdd(!checkedAdd)
    if (e.target.name === "addressName") {
      // console.log(e.target.value)
      if (e.target.value.length >= 4) {
        setFormErrors("");
      } else {
        setFormErrors("Save Address alias, minimum 4 length");
      }
      setUser({ ...user, [e.target.name]: e.target.value });
    } else if (e.target.name === "mobile") {
      if (e.target.value.length <= 10) {
        if (e.target.name === "mobile" && e.target.value.length === 10) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter 10 digit mobile no");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "pinCode") {
      if (e.target.value.length <= 6) {
        if (e.target.name === "pinCode" && e.target.value.length === 6) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter 6 digit pinCode");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "address") {
      if (e.target.value.length <= 100) {
        if (e.target.name === "address" && e.target.value.length >= 10) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter 10 characters");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "landmark") {
      if (e.target.value.length <= 100) {
        if (e.target.name === "landmark" && e.target.value.length >= 10) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter 10 characters");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "state") {
      if (e.target.value.length <= 20) {
        if (e.target.name === "state" && e.target.value.length >= 3) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter state");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "city") {
      if (e.target.value.length <= 20) {
        if (e.target.name === "city" && e.target.value.length >= 3) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter city");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "email") {
      const data = emailValidation();
      if (data) {
        setFormErrors("");
        setUser({ ...user, [e.target.name]: e.target.value });
      } else {
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "isDefault") {
      // console.log(e.target.name, checkedAdd)
      setCheckedAdd(!checkedAdd);
      if (!checkedAdd) {
        // console.log(checkedAdd)
        setUser({ ...user, [e.target.name]: "Y" });
      } else {
        setUser({ ...user, [e.target.name]: "N" });
      }
    } else {
      // console.log(e.target.name,e.target.value)
      setUser({ ...user, [e.target.name]: e.target.value });
    }
  };

  const handleClick = () => {
    let loggedInStatus = localStorage.getItem("auth")
      ? localStorage.getItem("auth")
      : 0;
    if (loggedInStatus === 0) {
      setOpen(true);
    } else {
      if (document.querySelector(".content-apps")) {
        document.querySelector(".content-apps").scrollTo(0, 0);
      }
      return nav("/register");
    }
  };

  const fetchAddresses = () => {
    const userId = localStorage.getItem("auth");
    getAddress(userId)
      .then((resp) => {
        // console.log(resp.data.data)
        return resp.data;
      })
      .then((data) => {
        setAddressCards(data.data);
        data?.data?.map((item) => {
          if (shippingAddress === "" && item.isDefault === "Y") {
            setShippingAddress(item.addressId);
          }
          return item;
        });
      });
  };

  const handleClaimClick = async () => {
    const token = localStorage.getItem("auth");
    if (token == null) {
      setOpen(true);
    } else {
      if (shippingAddress.length > 2) {
        setShow(true);
      } else {
        setModalOpen(true);
        setShow(true);
      }
    }
  };

  const getEventDetailCall = async () => {
    setLoading(true);
    try {
      const res = await getEventDetail();
      setEventDetails(res.data.data);
      setIsNotification(res.data.data?.isNotification);
    } catch (error) {
      console.error("Failed to fetch event details:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStarTransactionsCall = async () => {
    setLoading(true);
    try {
      const res = await getStarTransactions();
      setStarTransaction(res?.data?.data?.earned);
    } catch (error) {
      console.error("Failed to fetch event details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFinalStep = async () => {
    try {
      const res = await claimReward(shippingAddress?.addressId);
      // const orderId = res.data.;
      if (res.data.status === 1) {
        // console.log("Reward claimed successfully:", res.data);
        // // nav(`/track?order_id=${orderId}`);
        nav(`/track?order_id=${res?.data?.order_id}`);
      } else {
        console.warn("Unexpected response format:", res);
        // Optionally show a message to user here
        setDisplay(true);
        setVarient("danger");
        setMsg(res.data.data.msg);
      }
    } catch (error) {
      console.error("Error claiming reward:", error);
      setDisplay(true);
      setVarient("danger");
      setMsg("Whoops! Something went wrong. Try Again");
    }
  };

  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => setShowAll((prev) => !prev);

  const visibleTransactions = showAll
    ? starTransaction
    : starTransaction?.slice(0, 5);

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleClose = () => setShow(false);

  const handleChangeModal = (address) => {
    // e.preventDefault();
    setShippingAddress(address);
    // console.log(address, "selected address");
    handleClose();
  };
  useEffect(() => {
    fetchAddresses();
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showAddForm, setShowAddForm] = useState(false);
  const handleDelete = async (address) => {
    if (!address?.addressId) {
      console.error("Invalid address data provided.");
      alert("Unable to delete. Address ID is missing.");
      return;
    }

    try {
      const res = await removeAddressId(address.addressId);

      if (res?.status === 200) {
        // Optionally refresh list or close modal
        setMsg("Address deleted successfully");
        setVarient("success");
        setDisplay(true);
        fetchAddresses();
        // handleShow(); // e.g., to show success toast/modal
        // handleClose(); // close modal if needed
      } else {
        setMsg("Unexpected response:", res);
        setVarient("danger");
        setDisplay(true);
        console.error("Unexpected response:", res);
        alert("Something went wrong while deleting the address.");
      }
    } catch (error) {
      console.error("Error deleting address:", error);
      if (error?.response?.data?.message) {
        alert(`Error: ${error.response.data.message}`);
      } else {
        alert("Network or server error occurred while deleting the address.");
      }
    } finally {
      setTimeout(() => {
        setDisplay("false");
        setMsg("");
      }, [3000]);
    }
  };

  return (
    <div
      className="mt-5 mb-5"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div
        className="container relative left-0 p-lg-5 mt-3"
        style={{ padding: "0", background: "black" }}
      >
        {eventDetails?.isWinner === "Y" ? (
          <div className="container-fluid px-0" style={{ overflowX: "hidden" }}>
            <div className="d-flex flex-column justify-content-center align-items-center text-center px-3 pt-5 position-relative overflow-hidden">
              {eventDetails.isClaimed === "N" && (
                <Confetti
                  width={dimensions.width}
                  height={dimensions.height}
                  style={{ zIndex: "0", opacity: "0.8" }}
                />
              )}

              <div style={{ zIndex: "1" }}>
                {" "}
                <h1 className="text-center my-4 w-100">
                  <img
                    src="/assets/images/congratulationText.png"
                    alt="Congratulations"
                    className="img-fluid mx-auto"
                    style={{ maxWidth: "90%", height: "auto" }}
                  />
                </h1>
                {/* Subtext */}
                <p className="text-white fs-5  mb-2 position-relative">
                  You’ve won an iPhone 16 ! 🎁
                </p>
                <div className="d-flex justify-content-center w-100">
                  <img
                    src="/assets/images/i-phone.png"
                    alt="iPhone Reward"
                    className="img-fluid shadow-lg mt-2 mb-4"
                    style={{ maxWidth: "180px", width: "60%", height: "auto" }}
                  />
                </div>
                {!localStorage.getItem("auth") ? (
                  <button
                    onClick={() => setOpen(true)}
                    className="btn btn-warning btn-lg fw-bold rounded-pill shadow mt-1 px-4"
                  >
                    LOGIN TO CLAIM REWARD
                  </button>
                ) : eventDetails.isClaimed === "N" ? (
                  shippingAddress?.addressId?.length > 0 ? (
                    <div>
                      <div className="text-muted" style={{ fontSize: "14px" }}>
                        You’re just one click away from claiming your Iphone 16{" "}
                      </div>
                      <button
                        onClick={() => {
                          handleFinalStep();
                        }}
                        className="btn btn-warning btn-lg fw-bold rounded-pill shadow mt-2 px-4"
                      >
                        CLAIM REWARD
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        handleClaimClick();
                        setShowAddForm(false);
                      }}
                      className=" btnPrimary btn-lg fw-bold rounded-pill shadow mt-1 px-4"
                    >
                      SELECT ADDRESS TO CLAIM
                    </button>
                  )
                ) : (
                  <div className="d-flex justify-content-center mt-3">
                    <div
                      className="alert alert-warning text-center fw-semibold px-2 py-1 mt-1 mb-2"
                      role="alert"
                      style={{ fontSize: "1rem" }}
                    >
                      Reward is already claimed
                    </div>
                  </div>
                )}
              </div>
              {!localStorage.getItem("auth") && (
                <div className="d-flex justify-content-center mt-3">
                  <div
                    className="alert alert-warning text-center fw-semibold px-2 py-1 mt-1 mb-2"
                    role="alert"
                    style={{ fontSize: "1rem" }}
                  >
                    🔒 Login first to claim the reward !
                  </div>
                </div>
              )}

              <div className="rowGap10"></div>
              <div className="rowGap10"></div>
            </div>
            {shippingAddress?.addressId?.length > 0 && (
              <div
                className="p-3 my-2 rounded"
                style={{
                  border: "1px solid #0d6efd",
                }}
              >
                <div className="d-flex justify-content-between  align-items-center">
                  <strong>Shipping To:</strong>{" "}
                  <div className="btn btn-link" onClick={() => setShow(true)}>
                    <i class=" fa fa-sync"></i>Change
                  </div>
                </div>

                <div style={{ lineHeight: "1.5", marginTop: "0.5rem" }}>
                  {shippingAddress.address_string}
                </div>
              </div>
            )}
            <div class="d-flex justify-content-center align-items-center  mb-5 text-muted small">
              <span>Terms and Conditions</span>
              <a
                href="/terms"
                class="ms-2 text-decoration-none fw-medium text-primary"
              >
                Know more
              </a>
            </div>
          </div>
        ) : (
          <div
            className="content-apps "
            style={{ overflowX: "hidden", position: "relative" }}
          >
            {isNotification === "Y" ? (
              <div
                className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.7)", zIndex: 1050 }}
              >
                <div
                  className="card text-center p-3 m-2"
                  style={{
                    borderRadius: "10px",
                    background:
                      "linear-gradient(to bottom right, rgb(0, 47, 113), rgb(0, 28, 62))",
                    maxWidth: "100%",
                    width: "400px",
                    position: "relative",
                  }}
                >
                  {/* Floating Image */}
                  <div className="d-flex justify-content-center position-relative">
                    <img
                      src="/assets/images/cong-reward-img.png"
                      alt="Success"
                      style={{
                        width: "100%",
                        maxWidth: "260px",
                        height: "auto",
                        position: "absolute",
                        top: "-100px",
                      }}
                    />
                  </div>

                  {/* Spacer for the floating image */}
                  <div style={{ height: "100px" }}></div>
                  <small className="text-light mb-2 mt-1">
                    Play. Win. Repeat.
                    <br />
                  </small>
                  {/* Reward Box */}
                  <div
                    className="p-3 mt-2 mx-auto"
                    style={{
                      border: "1px dashed gold",
                      borderRadius: "20px",
                      background: "rgba(255,255,255,0.05)",
                      width: "100%",
                    }}
                  >
                    <div className="fw-bold mb-2" style={{ fontSize: "15px" }}>
                      YOU EARNED
                    </div>
                    <div className="badge mt-2 d-flex justify-content-center align-items-center gap-2">
                      <h1
                        className="fw-bolder m-0"
                        style={{
                          color: "gold",
                          textShadow: "1px 1px 4px gold",
                        }}
                      >
                        1
                      </h1>
                      <img
                        src="/assets/images/mvp_tag.png"
                        alt="star"
                        style={{ width: "40px", height: "auto" }}
                      />
                    </div>
                    <div>
                      <span
                        style={{
                          color: "gold",
                          fontWeight: "bolder",
                          fontSize: "18px",
                        }}
                      >
                        MVP Tag
                      </span>
                    </div>
                  </div>

                  {/* Subtitle */}
                  <small className="text-light mb-2 mt-3">
                    <strong>
                      Become an MVP, earn MVP tags, and win an iPhone!
                    </strong>
                  </small>

                  {/* Close Button */}
                  <div style={{ padding: "3px 30px" }}>
                    <button
                      className="btn btn-warning w-100 fw-bold"
                      style={{ padding: "8px 0px", border: "none" }}
                      onClick={() => setIsNotification("N")}
                    >
                      CLOSE
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="mt-4" style={{ position: "relative" }}>
                <div
                  className="container text-center mt-5"
                  style={{
                    backgroundImage:
                      'url("https://appcdn.goqii.com/storeimg/32341_1747896295.png")',
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    boxShadow: "inset 0 -10px 15px rgba(0, 0, 0, 0.7)",
                    position: "relative",
                  }}
                >
                  <strong>
                    <h2
                      className="fw-bold mt-5"
                      style={{ fontWeight: "5rem", fontSize: "1.2rem" }}
                    >
                      GET <span style={{ color: "#FFD700" }}>FAU-G</span> MVP
                      TAGS,
                      <br />
                      WIN AN IPHONE
                    </h2>
                  </strong>
                  {/* 
                  <div
                    className="fw-bold"
                    style={{ marginTop: "18px", fontSize: "0.9rem" }}
                  >
                    <span style={{ marginRight: "10px", color: "#FFD700" }}>
                      • COLLECT TAGS
                    </span>
                    {eventDetails?.isRegistered === "N" && (
                      <span style={{ marginRight: "10px", color: "#FFD700" }}>
                        • SIGN UP
                      </span>
                    )}

                    <span style={{ color: "#FFD700" }}>• GET IPHONE</span>
                  </div> */}

                  <div
                    className="d-flex justify-content-center"
                    style={{ position: "relative", marginTop: "50px" }}
                  >
                    <img
                      // src="https://appcdn.goqii.com/storeimg/80233_1747897246.png"

                      src="/assets/images/ipho.png"
                      alt="iPhone"
                      style={{
                        width: "140%",
                        // borderRadius: "15px",
                        boxShadow: "inset 0 -10px 15px rgba(0, 0, 0)",
                        // maxWidth: "300px",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        backgroundColor: "#FFD700",
                        color: "#000",
                        padding: "4px 8px",
                        fontWeight: "bold",
                        borderRadius: "3px",
                        fontSize: "0.75rem",
                      }}
                    >
                      LIMITED TIME!
                    </div>
                  </div>

                  <div
                    className="d-flex justify-content-center"
                    style={{
                      position: "absolute",
                      bottom: "7px",
                      width: "100%",
                    }}
                  >
                    {" "}
                    <Link
                      className="btn btn-outline-light mt-2 px-4 py-2"
                      onClick={() => {
                        const element =
                          document.getElementById("icespice-details");
                        if (element) {
                          element.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                          }); // Added block: "center"
                        }
                      }}
                      style={{
                        backgroundColor: "#00000087",
                        // position: "absolute",
                        // bottom: "7px",
                        // left:'50%',
                        boxShadow: "none",
                        color: "white",
                        cursor: "pointer",
                      }}
                    >
                      Know More
                    </Link>
                  </div>
                </div>
                {/* <hr /> */}
                {eventDetails?.isRegistered === "N" ? (
                  <section
                    className=""
                    style={{
                      backgroundColor: "#000",
                      color: "#fff",
                      padding: "20px 0",
                    }}
                  >
                    <div className="container text-center mt-4">
                      <style>{`
        .transition-box {
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          transition: all 0.4s ease-in-out;
        }

        .transition-box.open {
          max-height: 200px; /* Adjust as needed */
          opacity: 1;
        }
      `}</style>

                      <div
                        className="card-body text-center mt-3"
                        style={{ fontFamily: "Teko, sanserif" }}
                      >
                        <Gift
                          size={48}
                          className="text-danger mb-3"
                          style={{ animation: "bounce 2s infinite" }}
                        />
                        <h1 className="fw-bold text-warning">
                          Register to Compete and Win!
                        </h1>

                        <button
                          onClick={() => handleClick()}
                          className="btn btn-gradient px-4 py-2 fw-semibold rounded-pill shadow mt-4"
                        >
                          Login to Register
                        </button>
                        <div
                          className=" alert alert-warning mt-5 p-2 text-center"
                          style={{
                            color: "red !important",
                            fontSize: "15px",
                            width: "100% !important",
                          }}
                        >
                          claim{" "}
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            50
                            <img
                              src="/assets/images/spicegold.png"
                              alt="SpiceGold"
                              style={{ width: "23px", margin: "0 4px" }}
                            />
                          </span>
                          upon successful registration!
                        </div>
                      </div>
                    </div>
                  </section>
                ) : (
                  <section
                    className=""
                    style={{
                      backgroundColor: "#000",
                      color: "#fff",
                      padding: "20px 0",
                      fontFamily: "Teko, sanserif",
                    }}
                  >
                    {" "}
                    <div className="container text-center mt-4">
                      <div className="">
                        {" "}
                        <div
                          className=" fs-3 text-muted  d-flex justify-content-center"
                          style={{
                            marginBottom: "3px !important",
                            animation: "smoothBlink 2s ease-in-out infinite",
                          }}
                        >
                          <span> The contest is live! </span>
                          {/* <span> Winner will be announced soon.</span> */}
                        </div>
                      </div>
                      <div
                        className=" fs-3 text-muted  d-flex justify-content-center"
                        style={{
                          animation: "smoothBlink 2s ease-in-out infinite",
                        }}
                      >
                        {/* <span> The contest is live! </span> */}
                        <span> Winner will be announced soon.</span>
                      </div>
                    </div>
                    <div
                      className="mt-3 p-4"
                      style={{
                        backgroundImage:
                          'url("https://appcdn.goqii.com/storeimg/21688_1747655703.png")',
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                      }}
                    >
                      <div className=" d-flex justify-content-center">
                        <div
                          className="p-4  w-80 "
                          style={{
                            border: "1px dashed gold",
                            borderRadius: "20px",
                            background: "rgba(255,255,255,0.05)",
                          }}
                        >
                          {" "}
                          <div
                            className="d-flex justify-content-center align-items-center "
                            style={{
                              fontSize: "70px",
                              fontWeight: 800,
                              color: "#FFD700",
                              textShadow: "0 0 10px #FFD700",
                              flexWrap: "wrap",
                            }}
                          >
                            {eventDetails?.isRegistered === "N" ? (
                              <i className="fa fa-lock"></i>
                            ) : (
                              eventDetails?.star
                            )}
                            <img
                              src="/assets/images/mvp_tag.png"
                              alt="MVP"
                              style={{ width: "50px", marginLeft: "8px" }}
                            />
                          </div>
                          <div
                            className="d-flex justify-content-center mt-3"
                            style={{ fontSize: "18px" }}
                          >
                            {" "}
                            Your Total MVP Tags
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-center gap-3 mb-2 ">
                        <span style={{ fontSize: "30px" }}>{statusIcon}</span>

                        <span
                          className=" fw-bold mt-1"
                          style={{ color: "gold", fontSize: "1.5rem" }}
                        >
                          {eventDetails?.top} MVPs
                        </span>
                      </div>

                      <div
                        className="mt-4 p-2 bg-dark border-start border-4 border-warning text-light rounded shadow-sm"
                        style={{ fontSize: "17px" }}
                      >
                        <p className="mb-1 text-info">
                          <i className="bi bi-star-fill me-2 text-warning"></i>
                          Only one winner will be awarded.
                        </p>
                        <p className="mb-0 text-success">
                          <i className="bi bi-trophy-fill me-2 text-warning"></i>
                          The player with the highest MVP Tags will be the
                          winner.
                        </p>
                      </div>
                    </div>
                    <div className=" d-flex justify-content-center align-items-center mt-1">
                      <div className="text-center text-light">
                        <style>{`
  @keyframes smoothBlink {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
`}</style>
                      </div>
                    </div>
                  </section>
                )}

                <hr style={{ backgroundColor: "#fff", margin: "40px 0" }} />
                <div className="container text-center mt-5">
                  {" "}
                  <h2 style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                    MORE FREEBIES WITH{" "}
                    <span style={{ color: "#FFD700" }}>SPICEGOLD</span>
                  </h2>
                  <div
                    className="text-center py-4 mt-4"
                    style={{
                      backgroundColor: "#000",
                      position: "relative",
                      overflow: "hidden",
                      backgroundImage: 'url("/assets/images/confetti.png")',
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  >
                    {/* Confetti effect — optional background */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage:
                          "url('https://cdn.pixabay.com/photo/2017/06/02/18/24/confetti-2366124_1280.png')", // Replace with your confetti background or leave it black
                        backgroundRepeat: "repeat",
                        backgroundSize: "contain",
                        opacity: 0.2,
                        zIndex: 0,
                      }}
                    ></div>

                    {/* Cards Section */}
                    <div
                      className="d-flex justify-content-center align-items-center mt-2"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <img
                        src="https://appcdn.goqii.com/storeimg/32720_1747736339.png" // Replace with actual blue card image
                        alt="Blue Card"
                        style={{
                          width: "170px",
                          borderRadius: "10px",
                          transform: "rotate(-10deg)",
                          marginRight: "-40px",
                          boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
                          zIndex: 1,
                        }}
                      />
                      <img
                        src="https://appcdn.goqii.com/storeimg/49401_1747654143.png "
                        alt="Freebies Card"
                        style={{
                          width: "170px",
                          borderRadius: "10px",
                          transform: "rotate(-10deg)",
                          boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
                          zIndex: 2,
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-center flex-wrap gap-4 text-start teko"
                    style={{
                      padding: "15px",
                      maxWidth: "900px",
                      margin: "auto",
                      fontSize: "1.5rem",
                      // fontFamily: "Teko, sans-serif",
                    }}
                  >
                    <div
                      className="d-flex justify-content-start "
                      style={{ minWidth: "250px" }}
                    >
                      <span style={{ color: "#FFD700" }}>◆ </span> Get SpiceGold
                      by playing/winning specific events in FAU-G
                    </div>
                    <div
                      style={{ minWidth: "250px" }}
                      className="d-flex justify-content-start "
                    >
                      <span style={{ color: "#FFD700" }}>◆</span>
                      {eventDetails?.isRegistered === "N"
                        ? "Sign-up"
                        : "Sign-in"}{" "}
                      & check your SpiceGold account here on IceSpice
                    </div>
                    <div
                      style={{ minWidth: "250px" }}
                      className="d-flex justify-content-start flex-wrap "
                    >
                      <span style={{ color: "#FFD700" }}>◆</span> Get{" "}
                      <span style={{ color: "#00FFFF" }}> &nbsp;FREEBIES</span>,
                      discounts on{" "}
                      <span style={{ color: "#FFD700" }}>
                        &nbsp; GOODIES &nbsp;
                      </span>{" "}
                      and{" "}
                      <span style={{ color: "#FFD700" }}> E-GIFT CARDS</span>
                    </div>
                    <div className="text-center ">
                      {" "}
                      {/* Added a wrapper div for centering and margin */}
                      <button
                        className="animated-discount-btn"
                        onClick={() => {
                          // Logic to navigate to your discounts page or open a modal
                          // console.log("Navigating to discounts!");
                          nav("/discounts");
                          // Example navigation:
                          // nav('/discounts');
                        }}
                      >
                        {/* Using the Gift icon for allure */}
                        Explore Freebies Now!
                      </button>
                    </div>
                  </div>
                  <Link
                    // to="/spicegold-rewards"
                    className="btn btn-outline-light mt-2 px-4 py-2"
                    onClick={() => {
                      const element =
                        document.getElementById("spicegold-details");
                      if (element) {
                        element.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Know More
                  </Link>
                </div>

                {eventDetails?.isRegistered !== "N" && (
                  <>
                    {starTransaction && (
                      <div
                        className="game-card position-relative overflow-hidden overflow-x-auto mt-5"
                        style={{
                          padding: "20px",
                          width: "100%",
                          backgroundColor: "#1a1a1a", // Darker, more minimal background
                          // minHeight: "50vh",
                          // maxHeight:"80vh",
                          fontFamily: "Teko, sanserif !important",
                          borderRadius: "15px", // Slightly more rounded
                          boxShadow: "0 4px 15px rgba(0, 255, 255, 0.2)", // Subtle glow
                          transition: "all 0.3s ease-in-out", // Smooth transitions
                        }}
                      >
                        {/* Actual content area */}
                        <div
                          style={{
                            filter:
                              eventDetails?.isRegistered === "N"
                                ? "blur(2px)"
                                : "none", // Slightly more blur
                            pointerEvents:
                              eventDetails?.isRegistered === "N"
                                ? "none"
                                : "auto",
                            transition: "filter 0.3s ease-in-out", // Smooth blur transition
                          }}
                        >
                          <div className="mb-4 text-center">
                            <span className="d-flex justify-content-center align-items-center gap-2">
                              <img
                                src="/assets/images/mvp_tag.png"
                                style={{ width: "35px" }} // Slightly larger icon
                                alt="MVP Tag"
                              />
                              <h2
                                className="text-white mb-0"
                                style={{ fontSize: "24px", fontWeight: "bold" }}
                              >
                                MVP Transactions
                              </h2>
                            </span>
                            <small className="text-warning mt-2 d-block">
                              *MVP Tag expires after 90 days from the issue
                              date.
                            </small>
                          </div>

                          {/* Transaction List */}
                          <div
                            className="transaction-list-container"
                            style={{
                              // maxHeight: showAll ? "none" : "300px",
                              overflowY: "auto",
                            }}
                          >
                            {" "}
                            {/* Added max-height and overflow for scroll */}
                            {visibleTransactions?.length > 0 ? (
                              visibleTransactions.map((record) => (
                                <motion.div
                                  className="activity d-flex justify-content-between align-items-center py-3 "
                                  key={record.date}
                                  initial={{ opacity: 0, y: 20 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  transition={{ duration: 0.3 }}
                                  // Dotted border for a cleaner look
                                >
                                  <div className="activity-details text-start">
                                    <h5
                                      className="text-white mb-1"
                                      style={{ fontSize: "18px" }}
                                    >
                                      {record.eventTitle}
                                    </h5>
                                    <div
                                      className="activity-date text-muted"
                                      style={{ fontSize: "13px" }}
                                    >
                                      {record.date}
                                    </div>
                                  </div>
                                  <div className="spiceGold-value d-flex align-items-center">
                                    <h5
                                      className="text-success mb-0 me-1"
                                      style={{
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {record.rewardPoints}
                                    </h5>
                                    <img
                                      src="/assets/images/mvp_tag.png"
                                      style={{ width: "20px" }}
                                      alt="MVP Tag"
                                    />
                                  </div>
                                </motion.div>
                              ))
                            ) : (
                              <p className="text-muted text-center py-5">
                                No MVP transactions yet. Play to earn!
                              </p>
                            )}
                          </div>

                          {starTransaction.length > 5 && (
                            <div className="text-center mt-4">
                              <button
                                className="btn btn-outline-info btn-sm" // Slightly different button style
                                onClick={toggleShowAll}
                                style={{
                                  borderRadius: "20px",
                                  padding: "5px 15px",
                                  fontSize: "14px",
                                  borderColor: "#00FFFF",
                                  color: "#00FFFF",
                                }}
                              >
                                {showAll ? "Show Less" : "Show All History"}
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Overlay for "Locked" state */}
                        {eventDetails?.isRegistered === "N" && (
                          <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center p-4"
                            style={{
                              backgroundColor: "rgba(0,0,0,0.7)", // More opaque to clearly indicate locked state
                              borderRadius: "15px",
                              zIndex: 15, // Higher z-index to ensure it's on top
                              color: "#FFD700",
                              backdropFilter: "blur(5px)", // Keep blur for effect
                              gap: "15px", // Spacing between elements
                            }}
                          >
                            <Trophy
                              size={60}
                              className="text-warning animate-pulse-glow"
                            />{" "}
                            {/* Larger, more prominent icon */}
                            <h4
                              className="fw-bold mb-0"
                              style={{ fontSize: "1.8rem" }}
                            >
                              MVP Tags Locked!
                            </h4>
                            <p
                              className="text-white-50 mb-0"
                              style={{ fontSize: "1.1rem" }}
                            >
                              Register now to reveal your rewards history and
                              claim your glory!
                            </p>
                            <button
                              onClick={() => handleClick()} // Assuming handleClick is for login/registration
                              className="btn btn-warning fw-bold px-4 py-2 rounded-pill mt-3"
                              style={{ fontSize: "1.1rem" }}
                            >
                              Register to Unlock
                            </button>
                          </motion.div>
                        )}
                      </div>
                    )}
                  </>
                )}

                <div
                  id="icespice-details"
                  className="container my-5 p-4 rounded-4 shadow-lg gaming-card position-relative overflow-hidden animate-in" // Added gaming-card, rounded-4, position-relative, overflow-hidden, animate-in
                  style={{
                    border: "2px solid #00FFFF",
                    background: "linear-gradient(145deg, #1c002e, #000000)",
                    fontFamily: "'Press Start 2P', cursive",
                    fontSize: "1.1rem",
                    color: "#E0FFFF",
                    boxShadow: "0 0 25px rgba(0, 255, 255, 0.4)",
                  }}
                >
                  <div className="bg-pattern-top"></div>
                  <div className="bg-pattern-bottom"></div>

                  <h6 className="text-warning mb-4 text-center contest-title position-relative z-1">
                    ⚡IceSpice FAU-G MVP Tag iPhone Contest⚡
                  </h6>
                  <div className="contest-section position-relative z-1">
                    <h4 className="text-info section-heading">How to Play:</h4>{" "}
                    <p className="mb-2 gaming-text">
                      <i className="bi bi-controller me-2"></i>1. Dominate
                      FAU-G! Win an MVP, and a shining MVP Tag appears on your
                      post-match screen.
                    </p>
                    <p className="mb-2 gaming-text">
                      <i className="bi bi-hand-index-thumb me-2"></i>2. Tap that
                      MVP Tag! It's your portal to the IceSpice FAU-G MVP Tag
                      iPhone Contest Page.
                    </p>
                    <p className="mb-2 gaming-text">
                      <i className="bi bi-phone me-2"></i>3. Log your glory!
                      Track your MVP Tags by signing up with your mobile number
                      (OTP required – keep it safe!).
                    </p>
                    <p className="mb-2 gaming-text ">
                      <i className="bi bi-trophy me-2"></i>4. The ultimate
                      champion with the MOST MVP Tags at the end WINS a
                      brand-new iPhone 16 (128 GB)! Get tagging!
                    </p>
                    <hr />
                  </div>

                  {expanded && (
                    <div
                      className="contest-section position-relative z-1 collapse-animation"
                      id="icespice-details-expanded"
                    >
                      {" "}
                      <h4 className="text-info section-heading mt-4">
                        The Nitty-Gritty:
                      </h4>{" "}
                      <p className="mb-2 gaming-text">
                        <i className="bi bi-check-circle me-2"></i>1. By signing
                        up, you're accepting the Contest’s (and IceSpice’s) epic
                        <a
                          href="/terms"
                          class="ms-2 text-decoration-none fw-medium text-primary"
                        >
                          Terms and Conditions
                        </a>
                        . Game on!
                      </p>
                      <p className="mb-2 gaming-text">
                        <i className="bi bi-hourglass-split me-2"></i>2. The
                        contest runs for a thrilling 90 days, starting May 1,
                        2025. Mark your calendars!
                      </p>
                    </div>
                  )}

                  <div className="text-center mt-4 position-relative z-1">
                    {!expanded ? (
                      <button
                        className="btn btn-outline-warning btn-lg px-5 contest-button animate-button"
                        onClick={() => setExpanded(true)}
                        aria-expanded={expanded}
                        aria-controls="icespice-details-expanded"
                      >
                        Show Me The Details!{" "}
                        <i className="bi bi-chevron-down ms-2"></i>
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-warning btn-lg px-5 contest-button animate-button"
                        onClick={() => setExpanded(false)}
                        aria-expanded={expanded}
                        aria-controls="icespice-details-expanded"
                      >
                        Less Rules, More Action!{" "}
                        <i className="bi bi-chevron-up ms-2"></i>
                      </button>
                    )}
                  </div>
                </div>
                <hr></hr>
                <div
                  id="spicegold-details"
                  className="container my-5 p-4 rounded-4 shadow-lg gold-card position-relative overflow-hidden animate-in"
                  style={{
                    border: "2px solid #FFD700",
                    background: "linear-gradient(145deg, #2c3138, #1a1e22)",
                    fontFamily: "'Teko', sans-serif",
                    fontSize: "1.15rem",
                    color: "#e9ecef",
                    boxShadow: "0 0 25px rgba(255, 215, 0, 0.4)",
                  }}
                >
                  <div className="gold-pattern-top"></div>
                  <div className="gold-pattern-bottom"></div>

                  <h6 className="text-warning mb-4 text-center contest-title position-relative z-1">
                    <i className="bi bi-star-fill me-2"></i> SpiceGold &
                    Freebies! <i className="bi bi-star-fill ms-2"></i>
                  </h6>

                  <div className="section-content position-relative z-1">
                    <h4 className="text-light section-heading d-flex flex-wrap align-items-center mb-1">
                      {/* <i className="bi bi-coin me-2"></i>  */}
                      <div className="d-flex align-items-center justify-content-center">
                        <img
                          src="/assets/css/img/icespice-favicon-logo.png"
                          style={{ width: "4vw" }} // Keep the responsive width
                          alt="IceSpice Logo"
                          className=" mb-1 icespice-logo-enhanced-1" // Add the new class
                        />
                      </div>{" "}
                      &nbsp; &nbsp; Your Virtual Treasure: SpiceGold
                    </h4>
                    <p className="mb-2 gold-text mt-1">
                      1. SpiceGold is your exclusive virtual reward currency,
                      managed by IceSpice. Find the IceSpice Store right inside
                      the game!
                    </p>
                    <p className="mb-2 gold-text">
                      2. Earn SpiceGold by dominating in-game events like FAU-G
                      Domination. Psst... you can't buy this with real money –
                      it's pure skill!
                    </p>
                  </div>

                  {spicegoldExpanded && (
                    <div
                      className="section-content position-relative z-1 collapse-animation"
                      id="spicegold-details-expanded"
                    >
                      <div
                        className="d-flex justify-content-between align-items-center text-light mt-4"
                        style={{
                          borderBottom: " 1px dashed rgba(0, 255, 255, 0.3)",
                        }}
                      >
                        {" "}
                        <h4 className="text-light section-heading-no-border mt-4">
                          <i className="bi bi-gift-fill me-2"></i> Redeem Your
                          Rewards!
                        </h4>
                      </div>

                      <p className="mb-2 gold-text mt-1">
                        1. Spend your hard-earned SpiceGold to unlock amazing
                        discounts or claim awesome freebies in the IceSpice
                        Store.
                      </p>
                      <p className="mb-2 gold-text">
                        2. Freebies (like cool t-shirts, sleek backpacks, and
                        digital e-gift cards) are available in limited daily
                        drops! Check the store daily – first come, first served!
                      </p>
                      <p className="mb-2 gold-text">
                        3. Daily discounts on various products are up for grabs.
                        Use your SpiceGold for a massive discount, then pay the
                        rest seamlessly through the IceSpice Store’s secure
                        payment gateway.
                      </p>
                    </div>
                  )}

                  <div className="text-center mt-4 position-relative z-1">
                    {!spicegoldExpanded ? (
                      <button
                        className="btn btn-outline-warning btn-lg px-5 contest-button animate-button"
                        onClick={() => setSpicegoldExpanded(true)}
                        aria-expanded={spicegoldExpanded}
                        aria-controls="spicegold-details-expanded"
                      >
                        Show Me More!{" "}
                        <i className="bi bi-chevron-down ms-2"></i>
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-warning btn-lg px-5 contest-button animate-button"
                        onClick={() => setSpicegoldExpanded(false)}
                        aria-expanded={spicegoldExpanded}
                        aria-controls="spicegold-details-expanded"
                      >
                        Hide <i className="bi bi-chevron-up ms-2"></i>
                      </button>
                    )}
                  </div>
                </div>
                <div
                  class="d-flex justify-content-center align-items-center mt-3 text-muted small"
                  style={{ fontSize: "14px" }}
                >
                  <span></span>
                  <a
                    href="/terms"
                    class="ms-2 text-decoration-none fw-medium text-primary"
                  >
                    Terms and Conditions
                  </a>
                </div>
                <div className="rowGap10" />
              </div>
            )}
          </div>
        )}

        <BottomSheetCustom
          open={issOpen}
          handleClose={() => setOpen(!issOpen)}
          maxHeight="700px"
        >
          <BottomLogin onClose={() => setOpen(!issOpen)} />
        </BottomSheetCustom>
        <Modal show={show} onHide={handleClose}>
          <Modal.Body
            style={{
              maxHeight: showAddForm ? "85vh" : "65vh",
              overflowY: "auto",
            }}
          >
            {!showAddForm && (
              <>
                {" "}
                {addressCards && addressCards.length > 0 ? (
                  <div className="text-center mt-4 mb-3">
                    <h5 className="fw-bold mb-1" style={{ color: "#333" }}>
                      Select a Delivery Address
                    </h5>
                    <div
                      className="mx-auto mt-3"
                      style={{
                        height: "2px",
                        width: "30%",
                        backgroundColor: "#0dcaf0",
                        borderRadius: "5px",
                      }}
                    ></div>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center pt-5">
                    No Address added
                  </div>
                )}
                {display && (
                  <div
                    className="d-flex justify-content-center"
                    style={{ color: varient === "success" ? "#00e800" : "red" }}
                  >
                    {msg}
                  </div>
                )}
                <div className="rowGap10" />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    overflow: "scroll",
                    marginTop: "5px",
                  }}
                >
                  {addressCards?.map((address) => (
                    <div
                      key={address.addressId}
                      className="d-flex align-items-start flex-column rounded mx-2"
                      style={{
                        border: "2px solid #1C503B",
                        minWidth: "250px",
                        boxShadow:
                          address.addressId === shippingAddress.addressId
                            ? `0 3px 5px 0 ${
                                localStorage.getItem("theme") === "light"
                                  ? "#ebb511"
                                  : "#0dcaf0"
                              }`
                            : "none",
                      }}
                      onClick={() => handleChangeModal(address)}
                    >
                      <div className="">
                        <div className="p-3">
                          {" "}
                          <div className="d-flex align-items-start mb-2">
                            <input
                              type="radio"
                              style={{ display: "none" }}
                              id={address.addressId}
                              value={address.address_string}
                              name="name"
                              checked={
                                address.addressId === shippingAddress.addressId
                              }
                              onChange={(e) => {
                                handleChangeModal(e);
                              }}
                            />
                            <span>
                              <strong>{address.addressName}</strong>{" "}
                              {address.isDefault === "Y" && (
                                <sup style={{ color: "lightskyblue" }}>
                                  ( Default Address )
                                </sup>
                              )}
                            </span>
                          </div>
                          <div
                            className="text-muted small mb-2"
                            style={{ overflowY: "auto" }}
                          >
                            <span style={{ lineHeight: "1.4" }}>
                              {address.address_string}
                            </span>
                          </div>
                        </div>

                        <hr className="my-0" />

                        <div className="d-flex justify-content-between  align-items-center py-1 px-3">
                          <button
                            className="btn btn-link p-0"
                            onClick={(e) => {
                              e.preventDefault();
                              setShow(false);
                              nav("/contactForm", { state: address.addressId });
                            }}
                          >
                            EDIT
                          </button>
                          <span className="wt-btn-text">
                            <div
                              className="cta-with-loader"
                              style={{ color: "slategrey", cursor: "pointer" }}
                              onClick={() => handleDelete(address)}
                            >
                              REMOVE
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
            {!showAddForm && (
              <div className="container mt-3">
                <div className="d-flex justify-content-center p-3">
                  <div className="col-12">
                    <button
                      type="button"
                      className="btnPrimary"
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                        lineHeight: "1",
                      }}
                      onClick={() => {
                        if (localStorage.getItem("auth")) {
                          setShowAddForm(true);
                        } else {
                          setOpen(true);
                        }
                      }}
                    >
                      {localStorage.getItem("auth")
                        ? showAddForm
                          ? "Add New Address"
                          : "Add Address"
                        : "Login to Add Address"}
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showAddForm && (
              <>
                <div className="text-center mt-4 mb-3">
                  <h5 className="fw-bold mb-1" style={{ color: "#333" }}>
                    Add New Address
                  </h5>
                  <div
                    className="mx-auto mt-3"
                    style={{
                      height: "2px",
                      width: "30%",
                      backgroundColor: "#0dcaf0",
                      borderRadius: "5px",
                    }}
                  ></div>
                </div>

                <form action="" className="p-2">
                  <div className="d-flex justify-content-center  mb-2 text-muted">
                    <h7> Fill in the details below.</h7>
                  </div>
                  <label for="addressName" className="mt-2">
                    <h4>Address Name</h4>
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    value={user.addressName}
                    onChange={(e) => onValueChange(e)}
                    name="addressName"
                    className="input-1"
                  />

                  <label for="firstName" className="mt-2">
                    <h4>
                      First Name<span className="red-astrix">*</span>
                    </h4>
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    value={user.name}
                    onChange={(e) => onValueChange(e)}
                    name="name"
                    className="input-1"
                  />

                  <label for="mobile" className="mt-2">
                    <h4>
                      Mobile<span className="red-astrix">*</span>
                    </h4>
                  </label>
                  <input
                    type="number"
                    placeholder=""
                    name="mobile"
                    value={user.mobile}
                    onChange={(e) => onValueChange(e)}
                    className="input-1"
                  />

                  <label for="email" className="mt-2">
                    <h4>
                      Email<span className="red-astrix">*</span>
                    </h4>
                  </label>
                  <input
                    type="email"
                    placeholder="abc@example.com"
                    value={user.email}
                    onChange={(e) => onValueChange(e)}
                    name="email"
                    className="input-1 mt-2"
                  />

                  <label for="address" className="mt-2">
                    <h4>
                      Address<span className="red-astrix">*</span>
                    </h4>
                  </label>
                  <input
                    type="text"
                    placeholder="Adress Line 1"
                    name="address"
                    value={user.address}
                    onChange={(e) => onValueChange(e)}
                    className="input-1"
                  />
                  <input
                    type="text"
                    placeholder="Adress Line 2"
                    name="landmark"
                    value={user.landmark}
                    onChange={(e) => onValueChange(e)}
                    className="input-1 mt-2"
                  />
                  <div className="adress-line-3">
                    <input
                      type="number"
                      placeholder="PIN Code"
                      name="pinCode"
                      value={user.pinCode}
                      maxLength={6}
                      onChange={(e) => onValueChange(e)}
                      className="input-1 mt-2"
                    />
                    <input
                      type="text"
                      placeholder="City"
                      name="city"
                      value={user.city}
                      onChange={(e) => onValueChange(e)}
                      className="input-1 mt-2"
                    />

                    <select
                      name="state"
                      value={user.state}
                      onChange={(e) => onValueChange(e)}
                      className="input-1 mt-2"
                    >
                      <option value="">Select State</option>
                      <option value="Andhra Pradesh">Andhra Pradesh</option>
                      <option value="Arunachal Pradesh">
                        Arunachal Pradesh
                      </option>
                      <option value="Assam">Assam</option>
                      <option value="Bihar">Bihar</option>
                      <option value="Chhattisgarh">Chhattisgarh</option>
                      <option value="Goa">Goa</option>
                      <option value="Gujarat">Gujarat</option>
                      <option value="Haryana">Haryana</option>
                      <option value="Himachal Pradesh">Himachal Pradesh</option>
                      <option value="Jharkhand">Jharkhand</option>
                      <option value="Karnataka">Karnataka</option>
                      <option value="Kerala">Kerala</option>
                      <option value="Madhya Pradesh">Madhya Pradesh</option>
                      <option value="Maharashtra">Maharashtra</option>
                      <option value="Manipur">Manipur</option>
                      <option value="Meghalaya">Meghalaya</option>
                      <option value="Mizoram">Mizoram</option>
                      <option value="Nagaland">Nagaland</option>
                      <option value="Odisha">Odisha</option>
                      <option value="Punjab">Punjab</option>
                      <option value="Rajasthan">Rajasthan</option>
                      <option value="Sikkim">Sikkim</option>
                      <option value="Tamil Nadu">Tamil Nadu</option>
                      <option value="Telangana">Telangana</option>
                      <option value="Tripura">Tripura</option>
                      <option value="Uttar Pradesh">Uttar Pradesh</option>
                      <option value="Uttarakhand">Uttarakhand</option>
                      <option value="West Bengal">West Bengal</option>
                    </select>
                  </div>
                  <div className="rowGap10" />
                  <div className="form-outline mb-4">
                    <input
                      type="checkbox"
                      id="isDefault"
                      name="isDefault"
                      value="Y"
                      checked={checkedAdd}
                      onChange={(e) => onValueChange(e)}
                    />
                    <label htmlFor="isDefault">
                      &nbsp; Set as default Address
                    </label>
                  </div>
                  {formErrors != "" ? (
                    <div className={"alert alert-danger col-md-4"} role="alert">
                      {formErrors}
                    </div>
                  ) : null}
                  <button
                    className="btn-icespice"
                    onClick={(e) => submitHandle(e)}
                  >
                    {"Add Address"}
                  </button>
                  <div className="d-flex justify-content-center">
                    <div
                      className="wt-btn-text mt-4 "
                      style={{
                        color: "slategrey",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={(e) => setShowAddForm(false)}
                    >
                      {"Cancel"}
                    </div>
                  </div>
                </form>
              </>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Events;
